var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send-message",
    transform: "translate(-384 -15.195)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(384 15.195)",
    fill: "#1b145e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(396.076 25.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    "data-name": "Vector 90",
    d: "M1.7,17.223A2.476,2.476,0,0,1-.264,16.23a2.419,2.419,0,0,1-.385-2.147l1.7-5.847L-.649,2.39A2.419,2.419,0,0,1-.264.243,2.476,2.476,0,0,1,1.7-.75a2.429,2.429,0,0,1,1.182.309L14.759,6.09a2.45,2.45,0,0,1,0,4.293L2.884,16.914A2.429,2.429,0,0,1,1.7,17.223ZM1.7.75a.969.969,0,0,0-.767.393.919.919,0,0,0-.144.827L2.614,8.236.791,14.5a.919.919,0,0,0,.144.827.969.969,0,0,0,.767.393.946.946,0,0,0,.459-.123L14.036,9.069a.95.95,0,0,0,0-1.665L2.161.873A.946.946,0,0,0,1.7.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90-2",
    "data-name": "Vector 90",
    d: "M7.651,8.986H1.833a.75.75,0,0,1,0-1.5H7.651a.75.75,0,0,1,0,1.5Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.2945c329ae91f15dd17a2f8ced67842c.svg";
export { ForwardRef as ReactComponent };